// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"9af3772c","703":"0094ce12"}[chunkId] + ".chunk.js";
};